import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.page.html',
  styleUrls: ['./error.page.scss'],
})

export class ErrorPage {
  heroImage: string =
    'https://cdn.hyprop.co.za/image/2023/11/23/76b0cd18-b44c-496e-b375-c02f7691a976/d3f0a0ac-bc9a-49e5-b636-bc8ac1d8edd6.jpg';

  constructor(private router: Router) { }

  pageLink(link) {
    this.router.navigate([link], { replaceUrl: true });
  }
}
